import { ThemeProvider } from '@mui/material';
import { StylesProvider } from '@mui/styles';
import React from 'react';
import { TraxsmartTheme } from './schemes/TraxsmartTheme';
import { TraxsmartThemeDark } from './schemes/TraxsmartThemeDark';

const prefersDarkColorScheme = () =>
  window &&
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

// import { CacheProvider } from '@emotion/react';
// import createCache from '@emotion/cache';
// import stylisRTLPlugin from 'stylis-plugin-rtl';

// const cacheRtl = createCache({
//   key: 'swm-ui',
// prepend: true,
//
//   stylisPlugins: [stylisRTLPlugin]
// });

/**
 * Retrieves the default theme based on local storage or system preferences.
 */
const getDefaultTheme = () => {
  const appTheme = localStorage.getItem('appTheme');
  if (appTheme)
    return appTheme === 'light' ? TraxsmartTheme : TraxsmartThemeDark;

  const theme = prefersDarkColorScheme() ? TraxsmartThemeDark : TraxsmartTheme;
  if (prefersDarkColorScheme()) localStorage.setItem('appTheme', 'dark');
  else localStorage.setItem('appTheme', 'light');
  return theme;
};

export const ThemeContext = React.createContext();

export const useToggleTheme = () => React.useContext(ThemeContext);

const ThemeProviderWrapper = function (props) {
  // const curThemeName = localStorage.getItem('appTheme') || 'GreyGooseTheme';
  const [theme, setTheme] = React.useState(getDefaultTheme());

  const toggleTheme = () => {
    const appTheme = localStorage.getItem('appTheme');
    if (appTheme === 'light') {
      localStorage.setItem('appTheme', 'dark');
      setTheme(TraxsmartThemeDark);
    } else {
      localStorage.setItem('appTheme', 'light');
      setTheme(TraxsmartTheme);
    }
  };

  return (
    <StylesProvider injectFirst>
      {/* <CacheProvider value={cacheRtl}> */}
      <ThemeContext.Provider value={{ toggleTheme }}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </ThemeContext.Provider>
      {/* </CacheProvider> */}
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
